<div class="row">

  <div class="col">

    @if (dividends?.length) {
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col" class="text-center">Year</th>
            <th scope="col" class="text-right">Amount</th>
            @if (canEdit) {
              <th scope="col">&nbsp;</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (dividend of dividends; track dividend.id) {
            <tr>
              <td class="text-center">
                @if (canEdit) {
                  <span class="text-underline text-site-primary-alt pointable"
                        (click)="editDividend(dividend)"
                        title="View {{dividend.year}} Plan">
                    {{dividend.year}}
                  </span>
                } @else {
                  <span>{{dividend.year}}</span>
                }
              </td>
              <td class="text-right">{{dividend.amountPaid|currency}}</td>
              @if (canEdit) {
                <td class="text-center">
                  <button class="btn btn-sm btn-danger"
                          type="button"
                          (click)="deleteDividend(dividend)"
                          [disabled]="isDeleting">
                    <i class="far fa-trash-alt"></i>
                  </button>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    }

  </div>

  @if (canEdit) {
    <div class="col">

      @if (selectedDividend) {
        <div>

          <form [formGroup]="dividendForm"
                (ngSubmit)="saveDividend()"
                autocomplete="off"
                novalidate>

            <div class="row">

              <div class="col-sm-4">

                <div class="form-group"
                     [class.error]="yearDropdown.invalid && (yearDropdown.dirty || yearDropdown.touched || mouseoverDividendSubmit)">
                  <span class="fake-label">Year</span>
                  @if (yearDropdown.invalid && (yearDropdown.dirty || yearDropdown.touched || mouseoverDividendSubmit)) {
                    <em class="error-msg">
                      Req
                    </em>
                  }
                  <ng-select formControlName="yearDropdown"
                             bindLabel="description"
                             [clearable]="false"
                             (change)="onYearChange($event)"
                             required>
                     @for (year of years; track year.code) {
                     <ng-option [value]="year">{{year.description}}</ng-option>
                     }
                  </ng-select>
                </div>

              </div>

              <div class="col-sm-4">

                <div class="form-group"
                     [class.error]="amountPaid.invalid && (amountPaid.dirty || amountPaid.touched || mouseoverDividendSubmit)">
                  <span class="fake-label">Amount</span>
                  @if (amountPaid.invalid && (amountPaid.dirty || amountPaid.touched || mouseoverDividendSubmit)) {
                    <em class="error-msg">
                      Req
                    </em>
                  }
                  <input formControlName="amountPaid"
                         type="text"
                         name="amountPaid"
                         class="form-control text-right"
                         mask="separator.2"
                         thousandSeparator=","
                         maxlength="8" />
                  <!--currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.' }"-->
                </div>

              </div>

              <div class="col-sm-4 col-button text-center">

                <span (mouseenter)="mouseoverDividendSubmit=true" (mouseleave)="mouseoverDividendSubmit=false">
                  <app-button [buttonConfig]="{textChange: ['Add', 'Update']}"
                              [textChangeIndex]="+(!!(selectedDividend.id))"
                              [isLoading]="isSubmitting"
                              [disabled]="!dividendForm.valid || isSubmitting || isDeleting"
                              (textBtnClickEmt)="saveDividend()"></app-button>
                </span>

                @if (selectedDividend.id) {
                  <div>
                    <small class="pointable text-site-primary text-underline ps-2" (click)="clearSelectedDividend()">clear</small>
                  </div>
                }

              </div>

            </div>

          </form>

        </div>
      }

    </div>
  }

</div>

<ng-template app-confirm-simple>
  <app-confirm-modal-component></app-confirm-modal-component>
</ng-template>

